import { useTranslate } from "src/i18n";

interface IHowWeWorkSlides {
  title: string;
  text: string;
}

export const useHowWeWorkSlides = (): IHowWeWorkSlides[] => {
  const { t } = useTranslate();
  return [
    {
      title: t("landing.how_we_work_block.slide_1.title", "Регистрация"),
      text: t(
        "landing.how_we_work_block.slide_1.text",
        "Создайте учетную запись на платформе, указав email и пароль",
      ),
    },
    {
      title: t(
        "landing.how_we_work_block.slide_2.title",
        "Приобретение подписки",
      ),
      text: t(
        "landing.how_we_work_block.slide_2.text",
        "Выберите и оплатите подходящий тарифный план для доступа к функциям платформы",
      ),
    },
    {
      title: t("landing.how_we_work_block.slide_3.title", "Сбор ассортимента"),
      text: t(
        "landing.how_we_work_block.slide_3.text",
        "Выберете самые популярные и продаваемые товары на нашей платформе и загрузите к себе на сайте",
      ),
    },
    {
      title: t("landing.how_we_work_block.slide_4.title", "Запуск магазина"),
      text: t(
        "landing.how_we_work_block.slide_4.text",
        "Запускайте маркетинг для привлечения первых клиентов и начинайте получать прибыль",
      ),
    },
  ];
};
